export enum WebChatBotAccountMenuTab {
  generalInfo = "generalInfo",
  install = "install",
  chatAppearance = "chatAppearance",
}
